import React from 'react';
import { Stack, Paper, Skeleton } from "@mui/material";
import logo from '../resources/ember_logo_3d.png';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from "react";

function Stats() {

    const [loading, setLoading] = React.useState(true);
    const [streak, setStreak] = React.useState(0);
    const { user } = useAuth0();

    useEffect(() => {
        fetchStats();
    }, []);

    function fetchStats(){

        setLoading(true)

        const headers = new Headers();
        headers.append("x-functions-key", "MA157Yz391LafTKMbzgwXCjPxC-RP6ai3m8dbnfjOwAWAzFucv7XNg==");

        const requestOptions = {
            method: "GET",
            headers: headers,
            redirect: "follow"
        };

        const baseUri = "https://api-ember.azurewebsites.net"

        const url = baseUri + "/api/stats?user_id=" + user.sub;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                setStreak(result.streak);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }

    return (
        <Stack
            id="stats-and-tools"
            spacing={0}
            direction={'column'}
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
        >
            <Stack
                spacing={2}
                direction={'row'}
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                padding={0}
                sx={{
                    flexWrap: 'wrap',
                    gap: 1,

                }}
            >
                <Paper
                    variant="outlined"
                    sx={{
                        padding: 2,
                        borderRadius: 2.5,
                        background: '#fffbff',
                        borderColor: '#ffdad4',
                        // background: '#ffeaa7',
                        borderWidth: '0px',
                    }}
                >
                    <Stack
                        direction={'column'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        spacing={2}
                    >
                        <span
                            className="app-font"
                            style={{
                                color: '#3f0300',
                                fontSize: '2.2rem',
                                fontWeight: '700',
                                marginBottom: '-15px',
                            }}
                        >
                            {loading ?
                                <Skeleton variant='text' width={65} />
                                :
                                <><img src={logo} alt="Ember Logo" style={{ marginBottom: '-3px', marginRight: '-6px', width: '32px' }} />  {streak} </>
                            }
                        </span>
                        <span className="app-font" style={{ color: '#3f0300', fontSize: '0.8rem' }}>WEEKLY STREAK</span>
                    </Stack>
                </Paper>
            </Stack>
        </Stack>

    )
}

export { Stats };